import { useQuery } from '@tanstack/react-query';

import QueryKeys from '../../constants/queryKeys';

// services
import API from '../../services/api';

const getUserStatus = async () => {
    const { data } = await API.getUserStatus();
    return data;
};

export default function useUserStatusQuery() {
    return useQuery({
        queryKey: QueryKeys.userStatus,
        queryFn: () => getUserStatus(),
    });
}
